import React, { useState, useEffect } from 'react';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  FormFeedback,
} from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Flatpickr from 'react-flatpickr';
import { discountTypes } from './constants';
import InnerLoader from '../../../Components/Common/InnerLoader';
import CouponAdvancedOptions from './CouponAdvancedOptions';
const CouponForm = ({
  coupon,
  offset,
  promotionId,
  createOrUpdateCouponFunc,
  handleClose,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isEnableAdvancedOptions, setIsEnableAdvancedOptions] = useState(false);

  const formik = useFormik({
    initialValues: {
      couponCode: '',
      startsAt: null,
      expiresAt: null,
      discountType: 'fixed',
      discountValue: null,
      maxAmount: null,
      redeemableQuantity: 0,
      isOnlyUseCouponProductEligibility: false,
      isOnlyUseCouponRuleEligibility: false,
      productEligibility: { rule: null },
      ruleEligibility: { rule: null },
      memberPrimaryKeyType: 'Mobile',
      memberPrimaryKeyValues: '',
      isUseLauncherConfig: true,
      isUseConditionsAndTriggers: true,
    },
    onSubmit: async (values) => {
      try {
        setIsLoading(true);

        const coupons = [
          {
            code: values?.couponCode,
            startsAt: values?.startsAt,
            expiresAt: values?.expiresAt,
            redeemableQuantity: Number(values?.redeemableQuantity),
            _id: coupon?._id || null,
            promotionId: promotionId,
            isActive: !!coupon?.isActive,
            discountType: values?.discountType,
            discountValue: Number(values?.discountValue),
            maxAmount: Number(values?.maxAmount),
            isOnlyUseCouponProductEligibility:
              values?.isOnlyUseCouponProductEligibility,
            isOnlyUseCouponRuleEligibility:
              values?.isOnlyUseCouponRuleEligibility,
            productEligibility: values?.productEligibility,
            ruleEligibility: values?.ruleEligibility,
            memberPrimaryKeyType: values?.memberPrimaryKeyType,
            memberPrimaryKeyValues: values?.memberPrimaryKeyValues?.trim()
              ? values?.memberPrimaryKeyValues?.trim()?.split(',')
              : [],
            isUseLauncherConfig: values?.isUseLauncherConfig,
            isUseConditionsAndTriggers: values?.isUseConditionsAndTriggers,
          },
        ];

        await createOrUpdateCouponFunc(coupons, offset);
        setIsLoading(false);
        handleClose();
      } catch (e) {
        console.log(e);
        setIsLoading(true);
      }
    },
  });

  const {
    setValues,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    getFieldProps,
    values,
    touched,
    errors,
  } = formik;

  useEffect(() => {
    try {
      if (coupon) {
        setValues({
          couponCode: coupon?.code || '',
          startsAt: coupon?.startsAt ? new Date(coupon?.startsAt) : null,
          expiresAt: coupon?.expiresAt ? new Date(coupon?.expiresAt) : null,
          discountType: coupon?.discountType || 'fixed',
          discountValue: coupon?.discountValue || null,
          maxAmount: coupon?.maxAmount || null,
          redeemableQuantity: coupon?.redeemableQuantity || 0,
          isOnlyUseCouponProductEligibility:
            coupon?.isOnlyUseCouponProductEligibility || false,
          isOnlyUseCouponRuleEligibility:
            coupon?.isOnlyUseCouponRuleEligibility || false,
          productEligibility: { rule: coupon?.productEligibility?.rule },
          ruleEligibility: { rule: coupon?.ruleEligibility?.rule },
          memberPrimaryKeyType: coupon?.memberPrimaryKeyType,
          memberPrimaryKeyValues: coupon?.memberPrimaryKeyValues?.join(','),
          isUseLauncherConfig: coupon?.isUseLauncherConfig,
          isUseConditionsAndTriggers: coupon?.isUseConditionsAndTriggers,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [coupon]);

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={5}>
          <FormGroup>
            <Label for="couponCode">Coupon Code</Label>
            <Input
              id="couponCode"
              name="couponCode"
              type="text"
              value={values?.couponCode}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={touched?.couponCode && errors?.couponCode}
            />
            <FormFeedback>{errors?.couponCode}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <Label for="redeemableQuantity">Redeemable Quantity</Label>
            <Input
              id="redeemableQuantity"
              name="redeemableQuantity"
              type="number"
              value={values?.redeemableQuantity}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={
                touched?.redeemableQuantity && errors?.redeemableQuantity
              }
            />
            <FormFeedback>{errors?.redeemableQuantity}</FormFeedback>
          </FormGroup>
        </Col>

        <Col md={12}>
          <FormGroup>
            <div className="form-check form-switch form-switch-custom form-switch-dark d-flex gap-2 align-items-center p-0">
              <Label className="form-check-label" htmlFor="isUseLauncherConfig">
                Use Launcher Config
              </Label>
              <Input
                type="checkbox"
                className="form-check-input m-0"
                id="isUseLauncherConfig"
                {...getFieldProps('isUseLauncherConfig')}
                checked={values?.isUseLauncherConfig}
              />
            </div>
          </FormGroup>
        </Col>

        {!values.isUseLauncherConfig ? (
          <>
            <Col md={5}>
              <FormGroup>
                <Label for="startsAt">Start Date</Label>
                <Flatpickr
                  className="form-control"
                  value={values?.startsAt}
                  onChange={(dates) => setFieldValue('startsAt', dates[0])}
                  options={{ dateFormat: 'Y-m-d h:i K' }}
                />
                {touched?.startsAt && errors?.startsAt && (
                  <FormFeedback>{errors?.startsAt}</FormFeedback>
                )}
              </FormGroup>
            </Col>

            <Col md={5}>
              <FormGroup>
                <Label for="expiresAt">End Date</Label>
                <Flatpickr
                  className="form-control"
                  value={values?.expiresAt}
                  onChange={(dates) => setFieldValue('expiresAt', dates[0])}
                  options={{ dateFormat: 'Y-m-d h:i K' }}
                />
                {touched?.expiresAt && errors?.expiresAt && (
                  <FormFeedback>{errors?.expiresAt}</FormFeedback>
                )}
              </FormGroup>
            </Col>
          </>
        ) : null}

        <Col md={12}>
          <FormGroup>
            <div className="form-check form-switch form-switch-custom form-switch-dark d-flex gap-2 align-items-center p-0">
              <Label
                className="form-check-label"
                htmlFor="isUseConditionsAndTriggers"
              >
                Use conditions and triggers
              </Label>
              <Input
                type="checkbox"
                className="form-check-input m-0"
                id="isUseConditionsAndTriggers"
                {...getFieldProps('isUseConditionsAndTriggers')}
                checked={values.isUseConditionsAndTriggers}
              />
            </div>
          </FormGroup>
        </Col>

        {!values?.isUseConditionsAndTriggers ? (
          <>
            <Col md={5}>
              <FormGroup>
                <Label for="discountType">Discount Type</Label>
                <Input
                  type="select"
                  id="discountType"
                  name="discountType"
                  value={values?.discountType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  invalid={touched?.discountType && errors?.discountType}
                >
                  {discountTypes?.map((item) => (
                    <option key={item?.value} value={item?.value}>
                      {item?.label}
                    </option>
                  ))}
                </Input>
                <FormFeedback>{errors?.discountType}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={5}>
              <FormGroup>
                <Label for="discountValue">Discount Value</Label>
                <Input
                  id="discountValue"
                  name="discountValue"
                  type="number"
                  value={values?.discountValue}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  invalid={touched?.discountValue && errors?.discountValue}
                />
                <FormFeedback>{errors?.discountValue}</FormFeedback>
              </FormGroup>
            </Col>
            {values?.discountType === 'percentage' ? (
              <Col md={5}>
                <FormGroup>
                  <Label for="maxAmount">Max Amount</Label>
                  <Input
                    id="maxAmount"
                    name="maxAmount"
                    type="number"
                    value={values?.maxAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    invalid={touched?.maxAmount && errors?.maxAmount}
                  />
                  <FormFeedback>{errors?.maxAmount}</FormFeedback>
                </FormGroup>
              </Col>
            ) : null}
          </>
        ) : null}
      </Row>

      <div style={{ marginBottom: '100px' }}>
        <CouponAdvancedOptions
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          values={values}
          errors={errors}
          touched={touched}
        />
      </div>

      <Row className="position-fixed bottom-0 end-0 w-50 bg-white shadow p-3">
        <Col md={12} className="d-flex justify-content-end">
          <Button
            type="submit"
            color="primary"
            size="md"
            className="bg-gradient px-5"
            disabled={isLoading}
          >
            Update
          </Button>
        </Col>
      </Row>
      {isLoading && <InnerLoader />}
    </Form>
  );
};

export default CouponForm;
